import React, { useState, useEffect } from "react";

const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("clarityConsent");
    if (consent) return;

    fetch("https://get.geojs.io/v1/ip/country.json/")
      .then((res) => res.json())
      .then((data) => {
        const eeaCountries = [
          "AT",
          "BE",
          "BG",
          "CH",
          "CY",
          "CZ",
          "DE",
          "DK",
          "EE",
          "ES",
          "FI",
          "FR",
          "GR",
          "HR",
          "HU",
          "IE",
          "IS",
          "IT",
          "LI",
          "LT",
          "LU",
          "LV",
          "MT",
          "NL",
          "NO",
          "PL",
          "PT",
          "RO",
          "SE",
          "SI",
          "SK",
          "UK",
          "GB",
        
    
        ];
        if (eeaCountries.includes(data.country)) {
          setVisible(true);
        } else {
          loadClarityScript();
        }
      })
      .catch(() => {
        setVisible(true);
      });
  }, []);

  const loadClarityScript = () => {
    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", "r0icoagn77");
  };

  const handleConsent = (accepted) => {
    localStorage.setItem("clarityConsent", accepted ? "accepted" : "rejected");
    setVisible(false);

    if (typeof window.clarity === "function") {
      window.clarity("consent", accepted ? "granted" : "denied");
    }

    if (accepted) {
      loadClarityScript();
    }
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-black text-white border-t border-[#FFF528] py-4 px-8 sm:px-4 shadow-lg flex flex-row sm:flex-col md:flex-col md:gap-3 items-center justify-between">
      <div className="text-left mb-4 sm:mb-2 md:mb-0">
        <h2
          style={{ fontFamily: "Norwester" }}
          className="text-[#FFF528] text-xl sm:text-base  font-bold mb-3"
        >
          We value your privacy
        </h2>
        <p className="text-sm sm:text-xs sm:text-left mr-4 md:mr-0 sm:mr-0 text-gray-300 font-league-spartan leading-snug">
          Vupop and third parties use cookies and similar technologies on this
          app to collect information about your browsing activities, which we
          use to analyse your use of the app, personalise our services, and
          customise online advertisements.  For more details, please review our{" "}
  <a
    href="https://vupop.io/privacy-policy"
     target="_blank"
  rel="noopener noreferrer"
    className="underline hover:text-white"
  >
    Privacy Policy
  </a>. You can accept or reject analytics cookies.
        </p>
      </div>

      <div className="flex  gap-3 sm:gap-3 text-sm ">
        <button
          onClick={() => handleConsent(true)}
          className="bg-[#FFF528] text-black font-semibold rounded-lg px-12 py-2 sm:px-12 sm:py-2 sm:text-xs hover:bg-[#cec622] transition"
        >
          Accept
        </button>
        <button
          onClick={() => handleConsent(false)}
          className="border border-[#FFF528] text-[#FFF528] font-semibold rounded-lg px-12 py-2 sm:px-12 sm:py-2 sm:text-xs hover:bg-[#FFF528] hover:text-black transition"
        >
          Reject
        </button>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
